const landingTypesList = [
  '/',
  '/fullPrice',
  '/trial',
  '/main',
];

export default landingTypesList;
